var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentSynchronizationOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.172 5l4.076 4.659 1.505-1.317L10.81 6.12a6 6 0 016.497 8.682l1.769.934a8 8 0 00-8.48-11.611l2.158-2.466L11.248.342 7.172 5zm2.664-.007l.008.023L9.829 5l.007-.007z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.936 8.244a8 8 0 007.673 11.733l-2.316 2.316 1.414 1.414L16.414 19l-4.707-4.707-1.414 1.414 2.267 2.267a6 6 0 01-5.858-8.79l-1.766-.94z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentSynchronizationOutline);
export default __webpack_public_path__ + "c0a694ff0c17692aa2202cda9a23840b.svg";
export { ForwardRef as ReactComponent };